import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import { Sector } from '../../../app/models/Sector';
import useSectorService from '../../../app/services/hooks/useSectorService';
import SectorFormContainer from './SectorFormContainer';

interface Props {
    sectorId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const SectorEdit = ({ sectorId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { fetchingEditSector, editSector, fetchingUpdateSector, updateSector } =
        useSectorService();

    const [sector, setSector] = useState<Sector>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando sector...');
        editSector(sectorId, {
            onSuccess: (response: ServiceResponse) => {
                setSector(response.data.sector);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando sector...');
        updateSector(sectorId, sector, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, { autoClose: 2500 });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditSector ? (
        <LazyLoading height="300" />
    ) : (
        <SectorFormContainer
            fetching={fetchingUpdateSector}
            action={update}
            cancel={cancel}
            sector={sector}
            setSector={setSector}
            errorFields={errorFields}
        />
    );
};

export default SectorEdit;
